import { Color, Flex, FlexProps, Spacing } from '@billy/design-system'
import { PropsWithChildren } from 'react'

import * as Styled from './styles'

interface SalesReportColorBoxProps extends PropsWithChildren, FlexProps {
  color: Color
}

export const SalesReportColorBox = ({ color, children, ...rest }: SalesReportColorBoxProps) => {
  return (
    <Flex gap={Spacing.S4} {...rest}>
      <Styled.ColorBox color={color} />
      {children}
    </Flex>
  )
}
